var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Preturi: "),_c('span',{staticClass:"font-medium"},[_vm._v(" "+_vm._s(_vm.panouriPrice())+" ")]),_vm._v("/ "),_c('span',{staticClass:"font-medium"},[_vm._v(" "+_vm._s(_vm.poarta_pietonalaPrice())+" ")]),_vm._v("/ "),_c('span',{staticClass:"font-medium"},[_vm._v(" "+_vm._s(_vm.poarta_autoPriceStr())+" ")]),_vm._v(" eur ")])
}
var staticRenderFns = []

export { render, staticRenderFns }